/* global G */
import { curry } from 'lib/util'
import modified from 'model/ticket/collection/filter/modified'

/**
 * @param {Gaia.AppModule.Spec} module      app module
 * @param {Gaia.Component.Spec} component   action component
 * @param {Gaia.PlatformEvent} event        event
 * @returns {Array}
 */
// eslint-disable-next-line no-unused-vars
const listTicketFilterModified = (module, component, event) => modified.map(item => ({
  ...item,
  value: module[G.ADAPTER][G.INTL]._t(
    `filter.modified.${item.key}`,
    { ns: 'ticket', _key: `filter.modified.${item.key}`, defaultValue: item.value },
  ),
}))

export default curry(listTicketFilterModified)
